/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_SupportInputs */

const en_contact_topic_support = /** @type {(inputs: Contact_Topic_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help with the app`)
};

const pl_contact_topic_support = /** @type {(inputs: Contact_Topic_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomoc z aplikacją`)
};

/**
* | output |
* | --- |
* | "Help with the app" |
*
* @param {Contact_Topic_SupportInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_topic_support = /** @type {((inputs?: Contact_Topic_SupportInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_SupportInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_topic_support(inputs)
	return en_contact_topic_support(inputs)
});